import { KTIcon } from "../../../helpers"
import { SidebarMenuMain } from "./sidebar-menu/SidebarMenuMain"


type Props = {}

function OffCanVas({}: Props) {
  return (
    <div
      className='offcanvas offcanvas-start bg-black w-75'
      tabIndex={-1}
      id='offcanvasExample'
      aria-labelledby='offcanvasExampleLabel'
    >
      <div className='offcanvas-header'>
        <h5 className='offcanvas-title' id='offcanvasExampleLabel'></h5>
        <button type='button' className='btn-close text-light' data-bs-dismiss='offcanvas'>
          <KTIcon iconName='cross' className='fs-1' />
        </button>
      </div>
      <div className='offcanvas-body '>
        <SidebarMenuMain />
      </div>
    </div>
  )
}

export default OffCanVas
